import React from 'react';
import PropTypes from 'prop-types';

import { Dialog as MaterialDialog, DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent, Slide, IconButton } from '@mui/material';

import { BaIconClose } from 'components/ui/icons';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Dialog = ({
  className,
  pretitle,
  title,
  subtitle,
  children,
  preventClose,
  onClose,
  disableBackdropClick,
  DialogTitle,
  ...dialogProps
}) => {
  return (
    <MaterialDialog
      className={className}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      disableEscapeKeyDown={preventClose}
      scroll="paper"
      TransitionComponent={Transition}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' && disableBackdropClick) {
          return;
        }
        if (!preventClose) {
          onClose && onClose(event, reason);
        }
      }}
      {...dialogProps}
    >
      {DialogTitle ||
        <MuiDialogTitle>
          {pretitle}
          {!preventClose && onClose &&
            <IconButton onClick={onClose} alt="Close Dialog" title="Close Dialog" className="close-dialog-button"><BaIconClose/></IconButton>
          }
        </MuiDialogTitle>
      }
      <MuiDialogContent>
        {title &&
          <span className="dialog-title" id="dialog-title">
            {title}
          </span>
        }
        {subtitle &&
          <span className="dialog-subtitle" id="dialog-description">
            {subtitle}
          </span>
        }
        {children}
      </MuiDialogContent>
    </MaterialDialog>
  );
}

Dialog.defaultProps = {
  className: '',
  pretitle: undefined,
  title: '',
  subtitle: ''
};

Dialog.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  pretitle: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  preventClose: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  DialogTitle: PropTypes.node
};

export default Dialog;